import React from "react";
import { MessageCircle, MapPin, Phone, Gift, Home, BookOpen, Check } from "lucide-react";
import { whatsappGeneral } from "@/data/catalogHelpers";
import ScrollableArea from "./ScrollableArea";

export default function ContactPage({ studio, pageNumber, totalPages, onHome, onSummary }) {
  const s = studio || {};
  return (
    <div
      className="relative w-full h-full paper-bg flex flex-col overflow-hidden"
      data-testid="contact-page"
    >
      {s.contactImage && (
        <div className="absolute inset-0">
          <img src={s.contactImage} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 page-overlay" />
        </div>
      )}
      <div className="absolute inset-3 sm:inset-5 border border-[rgba(212,175,55,0.22)] pointer-events-none" />

      <ScrollableArea
        className="relative z-10 flex-1 min-h-0"
        contentClassName="flex flex-col items-center text-center px-6 py-5 pb-10"
        testid="contact-scroll"
      >
        <p className="font-body text-[0.56rem] uppercase tracking-[0.4em] text-[var(--gold)]">
          Contato & Agendamento
        </p>
        <h2 className="font-heading text-3xl sm:text-4xl text-[var(--offwhite)] leading-tight mt-2 max-w-xs">
          Seu momento de autocuidado começa aqui
        </h2>
        <div className="gold-hairline w-20 my-4" />

        <p className="font-script text-2xl text-[var(--champagne)]">
          {s.studioName || "Studio da Beleza"}
        </p>

        <div className="mt-4 space-y-2 text-[var(--offwhite)] font-body text-[0.72rem] tracking-wide max-w-[17rem]">
          <p className="flex items-start justify-center gap-2">
            <MapPin size={14} className="text-[var(--gold)] mt-0.5 shrink-0" strokeWidth={1.4} />
            {s.region}
          </p>
          <a
            href={whatsappGeneral(s.whatsapp)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-number"
            className="flex items-center justify-center gap-2 text-[var(--champagne)] hover:text-[var(--gold)] transition-colors"
          >
            <Phone size={14} className="text-[var(--gold)] shrink-0" strokeWidth={1.4} />
            {s.whatsappDisplay || "11 99547-0626"}
          </a>
          <p className="flex items-center justify-center gap-2">
            <Gift size={14} className="text-[var(--gold)] shrink-0" strokeWidth={1.4} />
            {s.giftLine}
          </p>
        </div>

        {/* Differentials */}
        <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2">
          {(s.differentials || []).map((d, i) => (
            <span
              key={i}
              className="flex items-center gap-1.5 font-body text-[0.62rem] uppercase tracking-[0.14em] text-[var(--nude)]"
            >
              <Check size={12} className="text-[var(--gold)]" strokeWidth={2} />
              {d}
            </span>
          ))}
        </div>

        <p className="font-script text-xl text-[var(--offwhite)] mt-5">
          {s.sloganSecondary || "Seu autocuidado é o seu melhor investimento!"}
        </p>

        {/* Buttons */}
        <div className="w-full max-w-[17rem] mt-6 space-y-2.5">
          <a
            href={whatsappGeneral(s.whatsapp)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-schedule-button"
            className="flex items-center justify-center gap-2 w-full py-3 bg-[var(--gold)] text-[var(--deep-black)] hover:bg-[var(--champagne)] transition-colors duration-300 uppercase tracking-[0.16em] text-[0.62rem] font-body font-semibold"
          >
            <MessageCircle size={14} strokeWidth={1.8} />
            Agendar pelo WhatsApp
          </a>
          <div className="flex gap-2.5">
            <button
              onClick={onHome}
              data-testid="contact-home-button"
              className="flex-1 flex items-center justify-center gap-1.5 py-2.5 border border-[rgba(212,175,55,0.4)] text-[var(--nude)] hover:border-[var(--gold)] hover:text-[var(--gold)] transition-colors duration-300 uppercase tracking-[0.12em] text-[0.58rem] font-body"
            >
              <Home size={12} strokeWidth={1.5} />
              Voltar ao início
            </button>
            <button
              onClick={onSummary}
              data-testid="contact-summary-button"
              className="flex-1 flex items-center justify-center gap-1.5 py-2.5 border border-[rgba(212,175,55,0.4)] text-[var(--nude)] hover:border-[var(--gold)] hover:text-[var(--gold)] transition-colors duration-300 uppercase tracking-[0.12em] text-[0.58rem] font-body"
            >
              <BookOpen size={12} strokeWidth={1.5} />
              Rever procedimentos
            </button>
          </div>
        </div>
      </ScrollableArea>

      <div className="relative z-10 shrink-0 flex items-center justify-between px-6 pb-4">
        <span className="font-body text-[0.55rem] tracking-[0.2em] text-[var(--muted)]">
          {String(pageNumber).padStart(2, "0")} / {String(totalPages).padStart(2, "0")}
        </span>
        <span className="font-body text-[0.5rem] uppercase tracking-[0.24em] text-[var(--muted)]">
          Studio da Beleza Bruna Reis
        </span>
      </div>
    </div>
  );
}
